export default __webpack_public_path__ + "static/media/icon_sharp-child-friendly.bf128117.svg";